import { KindergartenRoleEnum } from "@king-ict/eupisi-ui/models";

import { useTypedSelector } from "../../app/rootReducer";
import { CurrentUser } from "./types";

export type { CurrentUser };

export const useCurrentUser = (): CurrentUser => {
  const currentRole = useTypedSelector((s) => s.application.currentRole);

  return {
    userId: currentRole?.user?.id ?? 0,
    oib: currentRole?.user?.oib ?? "",
    firstName: currentRole?.user?.firstName ?? "",
    lastName: currentRole?.user?.lastName ?? "",
    roleId: currentRole?.role ?? KindergartenRoleEnum.Unknown,
    roleName: currentRole?.name ?? "",
    institutionId: currentRole?.locations?.[0]?.institutionId,
  };
};
